/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { cached } from '@glimmer/tracking';
import UiBookingPriceTablesBaseComponent from 'uplisting-frontend/components/ui/booking/price/tables/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class UiBookingPriceTablesPaymentsComponent extends UiBookingPriceTablesBaseComponent {
  @cached
  get payment(): ModelRegistry['booking-payment'] {
    return this.booking?.bookingPayment as ModelRegistry['booking-payment'];
  }

  @cached
  get payments(): ModelRegistry['payment'][] {
    const paidInvoices = this.booking.guestInvoices.filter(
      (invoice) => invoice.isPaid,
    );

    return this.payment.payments
      .concat(paidInvoices.map((invoice) => invoice.payment))
      .filter(Boolean);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Price::Tables::Payments': typeof UiBookingPriceTablesPaymentsComponent;
  }
}
